import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ICompanyChatMessagesClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanyChatMessagesClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class CompanyChatMessagesClient implements ICompanyChatMessagesClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, chatRoomId } = input;

        const PATH = `${API_LOCATION_URL}/company/chat_messages?chat_room_id=${chatRoomId}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
